import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TeamShortModal } from "app/components";
import { CONSTANTS } from "app/constants";
import { DrawingBasketDto, DrawingEuroPlayoffResultDto, FixtureDto, TeamShortDto } from "app/models";
import { DrawingsService, NotificationService } from "app/services";

@Component({
    selector: 'drawing-final',
    templateUrl: './drawing-final.component.html',
    styleUrls: ['./drawing-final.component.scss'],
})
export class DrawingFinal implements OnInit {

    @Input()
    lch: DrawingBasketDto;

    @Input()
    le: DrawingBasketDto;

    @Input()
    lk: DrawingBasketDto;

    const;

    matchDay1: number;
    
    @Input()
    fixtures: DrawingEuroPlayoffResultDto;

    constructor(private modalService: NgbModal, private notificationService: NotificationService,
        private drawingService: DrawingsService) {
        this.const = CONSTANTS;
     }

    ngOnInit(): void { 

   }

    onChangeTeam(index: number, basketNumber: number, tournament: number) {
        const modalRef = this.modalService.open(TeamShortModal);

        let basket = this.getBasket(basketNumber, tournament);

        modalRef.componentInstance.team = basket[index];

        modalRef.result.then((result) => {
            if (result) {
                basket[index] = result;
            }
        }, (reason) => { });
    }


    doDraw() {
        if (!this.matchDay1){
            this.notificationService.showError('Не выбран ИД!');
            return;
        }

        let allTeams = [];

        this.lch.basket1.forEach(item => {
            allTeams.push(item.id);
        });
        this.lch.basket2.forEach(item => {
            allTeams.push(item.id);
        });
        this.le.basket1.forEach(item => {
            allTeams.push(item.id);
        });
        this.le.basket2.forEach(item => {
            allTeams.push(item.id);
        });
        this.lk.basket1.forEach(item => {
            allTeams.push(item.id);
        });
        this.lk.basket2.forEach(item => {
            allTeams.push(item.id);
        });

        if (new Set(allTeams).size !== allTeams.length) {
            this.notificationService.showError('Среди команд есть дубли!');
            return;
        }

        this.drawingService.drawFinal(this.matchDay1, this.lch, this.le, this.lk)
            .subscribe(result => {
                this.notificationService.showSuccess("Жеребьевка проведелна");
                this.fixtures = result;
            }, error=> {
                this.notificationService.showError("Error!");
            })

        
    }

    isDrawn(): boolean {
        return false;

        return this.fixtures && this.fixtures.championsLeagureFixtures && this.fixtures.confferrenceLeagureFixtures && this.fixtures.euroLeagureFixtures
            && (this.fixtures.championsLeagureFixtures.length >0 || this.fixtures.confferrenceLeagureFixtures.length > 0 && this.fixtures.euroLeagureFixtures.length > 0);
    }

    private getBasket(basketNumber: number, tournament: number): TeamShortDto[] {
        let euroBasket: DrawingBasketDto;

        switch(tournament) {
            case CONSTANTS.euroCups.europeLeague:
                euroBasket = this.le;
                break;
            case CONSTANTS.euroCups.chamionsLeague:
                euroBasket = this.lch;
                break;
            case CONSTANTS.euroCups.conferenceLeague:
                euroBasket = this.lk;
                break;
        }

        return basketNumber === 1 ? euroBasket.basket1 : euroBasket.basket2;
    }

}

